export default __webpack_public_path__ + "static/media/myjourney-bluetree-nut.61ba15c1.svg";